'use client'
import React, { useRef, useEffect } from 'react'
import { SwiperSlide } from 'swiper/react'

import ZSwiper from '@/_components/universal/swiper/z-swiper'

import AContactCard, { IAContactCard } from './a-contact-swiper-card'

interface IZContactSwiperProps {
	title: string
	cards: IAContactCard[]
}

const AContactSwiper: React.FC<IZContactSwiperProps> = ({ title, cards }) => {
	const slidesRef = useRef<(HTMLDivElement | null)[]>([])

	useEffect(() => {
		const resizeSlides = () => {
			if (window.innerWidth >= 1026) {
				// desktop
				let maxHeight = 0
				slidesRef.current.forEach(slide => {
					if (slide) {
						slide.style.height = 'auto' // reset
						maxHeight = Math.max(maxHeight, slide.offsetHeight)
					}
				})
				slidesRef.current.forEach(slide => {
					if (slide) slide.style.height = maxHeight + 'px'
				})
			} else {
				slidesRef.current.forEach(slide => {
					if (slide) slide.style.height = 'auto'
				})
			}
		}

		resizeSlides()
		window.addEventListener('resize', resizeSlides)
		return () => window.removeEventListener('resize', resizeSlides)
	}, [cards])

	return (
		<section className='pos_rel oh mb-6 lg:mb-6 min-h-[550px] xl:min-h-[605px]'>
			<div className='cursordrag'>
				<div className='swiper-container swiper-contact -mt-5 xl:mt-0'>
					<ZSwiper
						spaceBetween={20}
						slidesPerGroup={1}
						navigationPosition='top'
						showCounter={false}
						showProgressbar={false}
						title={{ show: true, text: title }}
						breakpoints={{
							320: { slidesPerView: 1.1 },
							640: { slidesPerView: 2.1 },
							1026: { slidesPerView: 4.1 }
						}}
						className='swiper-contact'
					>
						{cards.map((card, index) => (
							<SwiperSlide key={index}>
								<div className='h-full flex flex-col items-stretch'>
									<AContactCard {...card} />
								</div>
							</SwiperSlide>
						))}
					</ZSwiper>
				</div>
			</div>
		</section>
	)
}

export default AContactSwiper
